/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Dyna ERP API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssetUploadResponse,
  ByProjectResponse,
  CreatePhotoReportTemplateParams,
  GetPhotoReportTemplateByProjectParams,
  ListOrgPhotosParams,
  ListPhotoReportTemplatesParams,
  MigratePhotoReportTemplateParams,
  MigrationPreview,
  OrgPhotoResponse,
  OrgPhotoUpdate,
  PaginatedResponseOrgPhotoResponse,
  PaginatedResponsePhotoReportTemplateResponse,
  PhotoReportTemplateCreate,
  PhotoReportTemplateResponse,
  PhotoReportTemplateUpdate,
  PreviewPhotoReportTemplateMigrationParams,
  TemplateMigrate,
  UploadOrgPhotoBody,
  UploadPhotoReportTemplateAssetBody
} from '../model';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Templates Endpoint
 */
export const listPhotoReportTemplates = (
    params?: ListPhotoReportTemplatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedResponsePhotoReportTemplateResponse>(
      {url: `/photo-report-templates/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListPhotoReportTemplatesQueryKey = (params?: ListPhotoReportTemplatesParams,) => {
    return [
    `/photo-report-templates/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPhotoReportTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError = unknown>(params?: ListPhotoReportTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPhotoReportTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPhotoReportTemplates>>> = ({ signal }) => listPhotoReportTemplates(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPhotoReportTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listPhotoReportTemplates>>>
export type ListPhotoReportTemplatesQueryError = unknown


export function useListPhotoReportTemplates<TData = Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError = unknown>(
 params: undefined |  ListPhotoReportTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhotoReportTemplates>>,
          TError,
          Awaited<ReturnType<typeof listPhotoReportTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhotoReportTemplates<TData = Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError = unknown>(
 params?: ListPhotoReportTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhotoReportTemplates>>,
          TError,
          Awaited<ReturnType<typeof listPhotoReportTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhotoReportTemplates<TData = Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError = unknown>(
 params?: ListPhotoReportTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Templates Endpoint
 */

export function useListPhotoReportTemplates<TData = Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError = unknown>(
 params?: ListPhotoReportTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhotoReportTemplates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPhotoReportTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Create Template Endpoint
 */
export const createPhotoReportTemplate = (
    photoReportTemplateCreate: PhotoReportTemplateCreate,
    params?: CreatePhotoReportTemplateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhotoReportTemplateResponse>(
      {url: `/photo-report-templates/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: photoReportTemplateCreate,
        params, signal
    },
      options);
    }




export const getCreatePhotoReportTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportTemplate>>, TError,{data: PhotoReportTemplateCreate;params?: CreatePhotoReportTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportTemplate>>, TError,{data: PhotoReportTemplateCreate;params?: CreatePhotoReportTemplateParams}, TContext> => {

const mutationKey = ['createPhotoReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPhotoReportTemplate>>, {data: PhotoReportTemplateCreate;params?: CreatePhotoReportTemplateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createPhotoReportTemplate(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePhotoReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof createPhotoReportTemplate>>>
    export type CreatePhotoReportTemplateMutationBody = PhotoReportTemplateCreate
    export type CreatePhotoReportTemplateMutationError = unknown

    /**
 * @summary Create Template Endpoint
 */
export const useCreatePhotoReportTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPhotoReportTemplate>>, TError,{data: PhotoReportTemplateCreate;params?: CreatePhotoReportTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPhotoReportTemplate>>,
        TError,
        {data: PhotoReportTemplateCreate;params?: CreatePhotoReportTemplateParams},
        TContext
      > => {
      return useMutation(getCreatePhotoReportTemplateMutationOptions(options), queryClient);
    }
    /**
 * @summary Get By Project Endpoint
 */
export const getPhotoReportTemplateByProject = (
    projectId: string,
    params?: GetPhotoReportTemplateByProjectParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ByProjectResponse>(
      {url: `/photo-report-templates/by-project/${projectId}/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPhotoReportTemplateByProjectQueryKey = (projectId: string,
    params?: GetPhotoReportTemplateByProjectParams,) => {
    return [
    `/photo-report-templates/by-project/${projectId}/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPhotoReportTemplateByProjectQueryOptions = <TData = Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError = unknown>(projectId: string,
    params?: GetPhotoReportTemplateByProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPhotoReportTemplateByProjectQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>> = ({ signal }) => getPhotoReportTemplateByProject(projectId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPhotoReportTemplateByProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>>
export type GetPhotoReportTemplateByProjectQueryError = unknown


export function useGetPhotoReportTemplateByProject<TData = Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError = unknown>(
 projectId: string,
    params: undefined |  GetPhotoReportTemplateByProjectParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportTemplateByProject<TData = Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError = unknown>(
 projectId: string,
    params?: GetPhotoReportTemplateByProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportTemplateByProject<TData = Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError = unknown>(
 projectId: string,
    params?: GetPhotoReportTemplateByProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get By Project Endpoint
 */

export function useGetPhotoReportTemplateByProject<TData = Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError = unknown>(
 projectId: string,
    params?: GetPhotoReportTemplateByProjectParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplateByProject>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPhotoReportTemplateByProjectQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Upload Asset Endpoint
 */
export const uploadPhotoReportTemplateAsset = (
    uploadPhotoReportTemplateAssetBody: UploadPhotoReportTemplateAssetBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, uploadPhotoReportTemplateAssetBody.file);

      return customInstance<AssetUploadResponse>(
      {url: `/photo-report-templates/upload-asset/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUploadPhotoReportTemplateAssetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>, TError,{data: UploadPhotoReportTemplateAssetBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>, TError,{data: UploadPhotoReportTemplateAssetBody}, TContext> => {

const mutationKey = ['uploadPhotoReportTemplateAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>, {data: UploadPhotoReportTemplateAssetBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadPhotoReportTemplateAsset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadPhotoReportTemplateAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>>
    export type UploadPhotoReportTemplateAssetMutationBody = UploadPhotoReportTemplateAssetBody
    export type UploadPhotoReportTemplateAssetMutationError = unknown

    /**
 * @summary Upload Asset Endpoint
 */
export const useUploadPhotoReportTemplateAsset = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>, TError,{data: UploadPhotoReportTemplateAssetBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadPhotoReportTemplateAsset>>,
        TError,
        {data: UploadPhotoReportTemplateAssetBody},
        TContext
      > => {
      return useMutation(getUploadPhotoReportTemplateAssetMutationOptions(options), queryClient);
    }
    /**
 * @summary List Org Photos Endpoint
 */
export const listOrgPhotos = (
    params?: ListOrgPhotosParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PaginatedResponseOrgPhotoResponse>(
      {url: `/photo-report-templates/photos/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListOrgPhotosQueryKey = (params?: ListOrgPhotosParams,) => {
    return [
    `/photo-report-templates/photos/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgPhotosQueryOptions = <TData = Awaited<ReturnType<typeof listOrgPhotos>>, TError = unknown>(params?: ListOrgPhotosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgPhotosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgPhotos>>> = ({ signal }) => listOrgPhotos(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgPhotos>>>
export type ListOrgPhotosQueryError = unknown


export function useListOrgPhotos<TData = Awaited<ReturnType<typeof listOrgPhotos>>, TError = unknown>(
 params: undefined |  ListOrgPhotosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgPhotos>>,
          TError,
          Awaited<ReturnType<typeof listOrgPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgPhotos<TData = Awaited<ReturnType<typeof listOrgPhotos>>, TError = unknown>(
 params?: ListOrgPhotosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgPhotos>>,
          TError,
          Awaited<ReturnType<typeof listOrgPhotos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgPhotos<TData = Awaited<ReturnType<typeof listOrgPhotos>>, TError = unknown>(
 params?: ListOrgPhotosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Org Photos Endpoint
 */

export function useListOrgPhotos<TData = Awaited<ReturnType<typeof listOrgPhotos>>, TError = unknown>(
 params?: ListOrgPhotosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgPhotos>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgPhotosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The org's default logo, or ``null`` if it has not chosen one.
 *
 * Ungated for the same reason ``GET /photos/`` is: the fill flow rehydrates
 * the logo a report stamps, and a regular worker holds no template
 * permission. Org scoping is the whole check.
 *
 * A literal path segment beside ``/photos/{photo_id}/``, which is
 * unambiguous here because no ``GET`` on that pattern exists -- the only
 * other reader of a single photo is the ``PATCH``.
 * @summary Get Default Org Logo Endpoint
 */
export const getDefaultOrgLogo = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrgPhotoResponse | null>(
      {url: `/photo-report-templates/photos/default/`, method: 'GET', signal
    },
      options);
    }




export const getGetDefaultOrgLogoQueryKey = () => {
    return [
    `/photo-report-templates/photos/default/`
    ] as const;
    }


export const getGetDefaultOrgLogoQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultOrgLogoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultOrgLogo>>> = ({ signal }) => getDefaultOrgLogo(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultOrgLogoQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultOrgLogo>>>
export type GetDefaultOrgLogoQueryError = unknown


export function useGetDefaultOrgLogo<TData = Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getDefaultOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultOrgLogo<TData = Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultOrgLogo>>,
          TError,
          Awaited<ReturnType<typeof getDefaultOrgLogo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultOrgLogo<TData = Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Default Org Logo Endpoint
 */

export function useGetDefaultOrgLogo<TData = Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultOrgLogo>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultOrgLogoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Upload Org Photo Endpoint
 */
export const uploadOrgPhoto = (
    uploadOrgPhotoBody: UploadOrgPhotoBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
formData.append(`file`, uploadOrgPhotoBody.file);

      return customInstance<OrgPhotoResponse>(
      {url: `/photo-report-templates/photos/upload/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getUploadOrgPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgPhoto>>, TError,{data: UploadOrgPhotoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadOrgPhoto>>, TError,{data: UploadOrgPhotoBody}, TContext> => {

const mutationKey = ['uploadOrgPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadOrgPhoto>>, {data: UploadOrgPhotoBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadOrgPhoto(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadOrgPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof uploadOrgPhoto>>>
    export type UploadOrgPhotoMutationBody = UploadOrgPhotoBody
    export type UploadOrgPhotoMutationError = unknown

    /**
 * @summary Upload Org Photo Endpoint
 */
export const useUploadOrgPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadOrgPhoto>>, TError,{data: UploadOrgPhotoBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadOrgPhoto>>,
        TError,
        {data: UploadOrgPhotoBody},
        TContext
      > => {
      return useMutation(getUploadOrgPhotoMutationOptions(options), queryClient);
    }
    /**
 * @summary Rename Org Photo Endpoint
 */
export const renameOrgPhoto = (
    photoId: string,
    orgPhotoUpdate: OrgPhotoUpdate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrgPhotoResponse>(
      {url: `/photo-report-templates/photos/${photoId}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: orgPhotoUpdate, signal
    },
      options);
    }




export const getRenameOrgPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameOrgPhoto>>, TError,{photoId: string;data: OrgPhotoUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameOrgPhoto>>, TError,{photoId: string;data: OrgPhotoUpdate}, TContext> => {

const mutationKey = ['renameOrgPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameOrgPhoto>>, {photoId: string;data: OrgPhotoUpdate}> = (props) => {
          const {photoId,data} = props ?? {};

          return  renameOrgPhoto(photoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameOrgPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof renameOrgPhoto>>>
    export type RenameOrgPhotoMutationBody = OrgPhotoUpdate
    export type RenameOrgPhotoMutationError = unknown

    /**
 * @summary Rename Org Photo Endpoint
 */
export const useRenameOrgPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameOrgPhoto>>, TError,{photoId: string;data: OrgPhotoUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameOrgPhoto>>,
        TError,
        {photoId: string;data: OrgPhotoUpdate},
        TContext
      > => {
      return useMutation(getRenameOrgPhotoMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Org Photo Endpoint
 */
export const deleteOrgPhoto = (
    photoId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/photo-report-templates/photos/${photoId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteOrgPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgPhoto>>, TError,{photoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrgPhoto>>, TError,{photoId: string}, TContext> => {

const mutationKey = ['deleteOrgPhoto'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrgPhoto>>, {photoId: string}> = (props) => {
          const {photoId} = props ?? {};

          return  deleteOrgPhoto(photoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrgPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrgPhoto>>>

    export type DeleteOrgPhotoMutationError = unknown

    /**
 * @summary Delete Org Photo Endpoint
 */
export const useDeleteOrgPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrgPhoto>>, TError,{photoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrgPhoto>>,
        TError,
        {photoId: string},
        TContext
      > => {
      return useMutation(getDeleteOrgPhotoMutationOptions(options), queryClient);
    }
    /**
 * Make this photo the org's default logo.
 *
 * PUT, not POST: one row per org, so this sets a value rather than appending
 * one, and sending it twice is the same as sending it once. Rides the same
 * permission as uploading and renaming -- choosing what every report stamps is
 * at least as consequential as adding a photo to the library.
 * @summary Set Default Org Logo Endpoint
 */
export const setDefaultOrgLogo = (
    photoId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OrgPhotoResponse>(
      {url: `/photo-report-templates/photos/${photoId}/default/`, method: 'PUT', signal
    },
      options);
    }




export const getSetDefaultOrgLogoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultOrgLogo>>, TError,{photoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultOrgLogo>>, TError,{photoId: string}, TContext> => {

const mutationKey = ['setDefaultOrgLogo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultOrgLogo>>, {photoId: string}> = (props) => {
          const {photoId} = props ?? {};

          return  setDefaultOrgLogo(photoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultOrgLogoMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultOrgLogo>>>

    export type SetDefaultOrgLogoMutationError = unknown

    /**
 * @summary Set Default Org Logo Endpoint
 */
export const useSetDefaultOrgLogo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultOrgLogo>>, TError,{photoId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultOrgLogo>>,
        TError,
        {photoId: string},
        TContext
      > => {
      return useMutation(getSetDefaultOrgLogoMutationOptions(options), queryClient);
    }
    /**
 * @summary Duplicate Template Endpoint
 */
export const duplicatePhotoReportTemplate = (
    templateId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhotoReportTemplateResponse>(
      {url: `/photo-report-templates/${templateId}/duplicate/`, method: 'POST', signal
    },
      options);
    }




export const getDuplicatePhotoReportTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>, TError,{templateId: string}, TContext> => {

const mutationKey = ['duplicatePhotoReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>, {templateId: string}> = (props) => {
          const {templateId} = props ?? {};

          return  duplicatePhotoReportTemplate(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicatePhotoReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>>

    export type DuplicatePhotoReportTemplateMutationError = unknown

    /**
 * @summary Duplicate Template Endpoint
 */
export const useDuplicatePhotoReportTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicatePhotoReportTemplate>>,
        TError,
        {templateId: string},
        TContext
      > => {
      return useMutation(getDuplicatePhotoReportTemplateMutationOptions(options), queryClient);
    }
    /**
 * Preflight a type migration — what it claims, what blocks it, who it touches.
 *
 * Read-only, and gated on ``:view`` rather than ``:edit`` so the confirmation
 * can be rendered by anyone who can open the editor; the write below still
 * needs ``:edit``.
 * @summary Preview Migration Endpoint
 */
export const previewPhotoReportTemplateMigration = (
    templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<MigrationPreview>(
      {url: `/photo-report-templates/${templateId}/migration-preview/`, method: 'GET',
        params, signal
    },
      options);
    }




export const getPreviewPhotoReportTemplateMigrationQueryKey = (templateId: string,
    params?: PreviewPhotoReportTemplateMigrationParams,) => {
    return [
    `/photo-report-templates/${templateId}/migration-preview/`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewPhotoReportTemplateMigrationQueryOptions = <TData = Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError = unknown>(templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewPhotoReportTemplateMigrationQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>> = ({ signal }) => previewPhotoReportTemplateMigration(templateId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewPhotoReportTemplateMigrationQueryResult = NonNullable<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>>
export type PreviewPhotoReportTemplateMigrationQueryError = unknown


export function usePreviewPhotoReportTemplateMigration<TData = Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError = unknown>(
 templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>,
          TError,
          Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewPhotoReportTemplateMigration<TData = Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError = unknown>(
 templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>,
          TError,
          Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewPhotoReportTemplateMigration<TData = Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError = unknown>(
 templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Preview Migration Endpoint
 */

export function usePreviewPhotoReportTemplateMigration<TData = Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError = unknown>(
 templateId: string,
    params: PreviewPhotoReportTemplateMigrationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewPhotoReportTemplateMigration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewPhotoReportTemplateMigrationQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Flip a template between Photo Report and JAC, keeping its layout and service types.
 *
 * 409 when a live template already holds a target project slot; ``?force=true``
 * narrow-detaches just those slots, matching create. Jobs with filled reports
 * never block — ``migration-preview`` lists them so the operator confirms
 * knowingly.
 * @summary Migrate Template Endpoint
 */
export const migratePhotoReportTemplate = (
    templateId: string,
    templateMigrate: TemplateMigrate,
    params?: MigratePhotoReportTemplateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhotoReportTemplateResponse>(
      {url: `/photo-report-templates/${templateId}/migrate/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: templateMigrate,
        params, signal
    },
      options);
    }




export const getMigratePhotoReportTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof migratePhotoReportTemplate>>, TError,{templateId: string;data: TemplateMigrate;params?: MigratePhotoReportTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof migratePhotoReportTemplate>>, TError,{templateId: string;data: TemplateMigrate;params?: MigratePhotoReportTemplateParams}, TContext> => {

const mutationKey = ['migratePhotoReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof migratePhotoReportTemplate>>, {templateId: string;data: TemplateMigrate;params?: MigratePhotoReportTemplateParams}> = (props) => {
          const {templateId,data,params} = props ?? {};

          return  migratePhotoReportTemplate(templateId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MigratePhotoReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof migratePhotoReportTemplate>>>
    export type MigratePhotoReportTemplateMutationBody = TemplateMigrate
    export type MigratePhotoReportTemplateMutationError = unknown

    /**
 * @summary Migrate Template Endpoint
 */
export const useMigratePhotoReportTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof migratePhotoReportTemplate>>, TError,{templateId: string;data: TemplateMigrate;params?: MigratePhotoReportTemplateParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof migratePhotoReportTemplate>>,
        TError,
        {templateId: string;data: TemplateMigrate;params?: MigratePhotoReportTemplateParams},
        TContext
      > => {
      return useMutation(getMigratePhotoReportTemplateMutationOptions(options), queryClient);
    }
    /**
 * One template by id -- **the read path for a frozen ``template_id``.**
 *
 * ``projects.JobReport.template_id`` freezes *which* template a report is
 * filled and judged against, so that an author reassigning a project's slot
 * mid-shift cannot retarget a report a technician is part-way through
 * (``projects.job_report_service._template_of``). Until this endpoint there
 * was no way to *read* that template: the only reads were the paginated list
 * and ``/by-project/``, which **re-resolves live**. So the fill page had to
 * resolve by project, and after any reassignment the two sides disagreed
 * permanently -- the page offered the new template's slots, ``save_draft``
 * judged them against the frozen one, and every answer for a slot only the
 * new template has came back 400 ("These keys are not on the Photo Report"),
 * through every reload, with the crew unable to record work they had already
 * uploaded photos for. The freeze was unreachable, which made it a trap
 * rather than a guarantee.
 *
 * Clients drawing a report therefore read the layout from **this** endpoint,
 * keyed by the report's ``template_id``, and fall back to ``/by-project/``
 * only when the report carries none.
 *
 * **Gated on ``jobs:view``, not on ``photo_report_templates:view``.** The
 * caller is a technician filling a report, who holds ``jobs:view`` and no
 * template permission at all; the editor permission would 403 the very callers
 * this exists for and leave them on the resolve endpoint it replaces. The fill
 * page is also its *only* caller -- the editor reads templates through the list
 * and merely sweeps this key on save -- so the narrower gate costs nothing.
 *
 * **Gated at all because ``@requires_permission`` is where the external-user
 * whitelist is consulted**, and that is a different control from the
 * permission key. An ``is_external`` caller is gated purely on their route
 * whitelist, and the test for it lives *inside* the decorator
 * (``auth_module._decorators``), so an undecorated route does not merely skip a
 * permission -- it skips the only control external users have, and any
 * client-portal token could read a full template payload by id. ``by-project``
 * and ``/photos/`` carry the same hole and predate this; that is a reason to
 * fix them, not to inherit it here.
 *
 * **It is a wider surface than ``by-project`` regardless.** That endpoint only
 * ever answers with a template *attached to a given project*; this one answers
 * with any live template in the caller's org by id, including org-level records
 * attached to no project at all (what ``POST /{id}/duplicate/`` produces) and
 * templates on projects the caller cannot see. Reaching one takes a guessed
 * UUIDv4 -- but ``template_id`` now rides on every ``JobReport`` the fill page
 * reads, so that mitigation is eroding, and this should be re-decided rather
 * than re-cited the next time template ids reach a new surface.
 *
 * Served by :func:`get_template_for_read`, **not** :func:`get_template`. The
 * two differ only in scoping -- ``org_scoped`` versus a hard ``org_id=`` filter
 * -- and they are separate functions because ``get_template`` is also the entry
 * point for every template WRITE. Widening it to un-404 a super-admin here
 * would have handed the same caller cross-org ``update``, ``delete``,
 * ``duplicate`` and both migration paths (see that function). Reading another
 * org's template by id is a disclosure the role already implies; writing one is
 * not.
 * @summary Get Template Endpoint
 */
export const getPhotoReportTemplate = (
    templateId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhotoReportTemplateResponse>(
      {url: `/photo-report-templates/${templateId}/`, method: 'GET', signal
    },
      options);
    }




export const getGetPhotoReportTemplateQueryKey = (templateId: string,) => {
    return [
    `/photo-report-templates/${templateId}/`
    ] as const;
    }


export const getGetPhotoReportTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError = unknown>(templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPhotoReportTemplateQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhotoReportTemplate>>> = ({ signal }) => getPhotoReportTemplate(templateId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPhotoReportTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getPhotoReportTemplate>>>
export type GetPhotoReportTemplateQueryError = unknown


export function useGetPhotoReportTemplate<TData = Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError = unknown>(
 templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportTemplate>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportTemplate<TData = Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError = unknown>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhotoReportTemplate>>,
          TError,
          Awaited<ReturnType<typeof getPhotoReportTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPhotoReportTemplate<TData = Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError = unknown>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Template Endpoint
 */

export function useGetPhotoReportTemplate<TData = Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError = unknown>(
 templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPhotoReportTemplate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPhotoReportTemplateQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update Template Endpoint
 */
export const updatePhotoReportTemplate = (
    templateId: string,
    photoReportTemplateUpdate: PhotoReportTemplateUpdate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<PhotoReportTemplateResponse>(
      {url: `/photo-report-templates/${templateId}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: photoReportTemplateUpdate, signal
    },
      options);
    }




export const getUpdatePhotoReportTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportTemplate>>, TError,{templateId: string;data: PhotoReportTemplateUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportTemplate>>, TError,{templateId: string;data: PhotoReportTemplateUpdate}, TContext> => {

const mutationKey = ['updatePhotoReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePhotoReportTemplate>>, {templateId: string;data: PhotoReportTemplateUpdate}> = (props) => {
          const {templateId,data} = props ?? {};

          return  updatePhotoReportTemplate(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePhotoReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updatePhotoReportTemplate>>>
    export type UpdatePhotoReportTemplateMutationBody = PhotoReportTemplateUpdate
    export type UpdatePhotoReportTemplateMutationError = unknown

    /**
 * @summary Update Template Endpoint
 */
export const useUpdatePhotoReportTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePhotoReportTemplate>>, TError,{templateId: string;data: PhotoReportTemplateUpdate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePhotoReportTemplate>>,
        TError,
        {templateId: string;data: PhotoReportTemplateUpdate},
        TContext
      > => {
      return useMutation(getUpdatePhotoReportTemplateMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Template Endpoint
 */
export const deletePhotoReportTemplate = (
    templateId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/photo-report-templates/${templateId}/`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePhotoReportTemplateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportTemplate>>, TError,{templateId: string}, TContext> => {

const mutationKey = ['deletePhotoReportTemplate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePhotoReportTemplate>>, {templateId: string}> = (props) => {
          const {templateId} = props ?? {};

          return  deletePhotoReportTemplate(templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePhotoReportTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deletePhotoReportTemplate>>>

    export type DeletePhotoReportTemplateMutationError = unknown

    /**
 * @summary Delete Template Endpoint
 */
export const useDeletePhotoReportTemplate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePhotoReportTemplate>>, TError,{templateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePhotoReportTemplate>>,
        TError,
        {templateId: string},
        TContext
      > => {
      return useMutation(getDeletePhotoReportTemplateMutationOptions(options), queryClient);
    }
